"use client";

import VerifyStandalone from "src/components/VerifyStandalone";

export default function VerifyPage() {
  return <VerifyStandalone />;
}
